module.exports = __webpack_public_path__ + "img/thumbnail_AfricanSpurredTortoise_f_normal.499ae6d2.png";